function round(number, precision) {
  const factor = 10 ** precision;
  const tempNumber = number * factor;
  const roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
}

export default function (value, precision = 0) {
  if (value) {
    return round(value, precision);
  }

  return 0;
}
